import { roundValue, safeParseFloat } from "lib/number";
import { loopNestedChildren } from "./ag-grid-helper";
import { MergedColumnFormulaOptions } from "./types";
import { UNITS as formulaUnits } from "../formulas/formula-units";
import { referenceMetricValueOrCompute } from "../sibling-value-getter";
import { ValueGetterParams } from "ag-grid-community";
import { MetricsKind } from "../types";
import { ColumnTypes } from "components/product-collection/product-collection-views/product-collection-grid-view/product-collection-grid-view-helper";

/**
 * Loop through row group children and recompute UNITS value.
 * This is very useful when we can't re-use computed values because UNITS metrics is not turned on, thus, the column doesn't exist.
 * @param factoryOptions
 * @param getterParams
 * @returns
 */
export const getChildrenUnits = (factoryOptions, getterParams) => {
    let sumValue = 0;
    const { node } = getterParams;
    loopNestedChildren(node, (childNode) => {
        const value = formulaUnits({
            factoryOptions,
            getterParams: {
                ...getterParams,
                node: childNode,
                data: childNode.data,
            },
        });

        sumValue += +(value ?? 0);
    });

    return sumValue;
};

/**
 * Get grand total units of the row
 */
export const getGrandTotalUnit = (options: MergedColumnFormulaOptions, valueGetterParams: ValueGetterParams) => {
    const unitsValue = referenceMetricValueOrCompute(
        () => {
            let totalUnits = 0;
            loopNestedChildren(valueGetterParams.node, (childNode) => {
                totalUnits += getChildrenUnits(
                    {
                        ...options,
                        deliveryId: null, // On purpose. Since this is to get grand total, `null` will count all deliveries
                        doors: Array.from(options.filteredDoorsForAssortmentSet.values()).map((door) => door), // On purpose. Since this is to get grand total, passing all doors being used will count all deliveries
                    },
                    {
                        ...valueGetterParams,
                        node: childNode,
                        data: childNode.data,
                    }
                );
            });

            return totalUnits;
        },
        valueGetterParams,
        MetricsKind.UNITS,
        valueGetterParams.node.id,
        ColumnTypes.AllDimensionTotal
    );

    return unitsValue;
};

/**
 * All this function does is summing values from children rows.
 */
export const UNITS = (values: number[], options: MergedColumnFormulaOptions) => {
    return roundValue(
        values.reduce((acc, value) => acc + safeParseFloat(value, 0), 0),
        options.decimal
    );
};
